import { useId } from "react";
import { DatePicker } from "@design-system/DatePicker/DatePicker";
import type { ScheduleMilestoneForm } from "./scheduleMilestoneFormHelpers";
import {
    MilestoneExampleDateForm,
    resolveMilestoneExampleDates,
    setMilestoneExampleDate,
} from "./scheduleMilestonePreviewHelpers";
import styles from "./ScheduleDrawer.module.scss";

interface ScheduleMilestonePreviewDatesProps {
    milestones: ScheduleMilestoneForm[];
    sourceDate: string;
    exampleDates: MilestoneExampleDateForm[];
    onExampleDatesChange: (exampleDates: MilestoneExampleDateForm[]) => void;
}

/** One example-day picker per milestone, two to a line, showing each resolved day. */
export const ScheduleMilestonePreviewDates = ({
    milestones,
    sourceDate,
    exampleDates,
    onExampleDatesChange,
}: ScheduleMilestonePreviewDatesProps) => {
    const labelIdPrefix = useId();
    const resolvedDates = resolveMilestoneExampleDates({
        milestones,
        sourceDate,
        exampleDates,
    });
    const overriddenKeys = new Set(exampleDates.map((example) => example.key));
    return (
        <div className={styles.milestoneExampleDates}>
            {milestones.map((milestone, index) => {
                const labelId = `${labelIdPrefix}-${milestone.key}`;
                return (
                    <div
                        key={milestone.key}
                        className={styles.milestoneExampleDate}
                    >
                        <span id={labelId} className={styles.inlineLabel}>
                            Milestone {index + 1}
                        </span>
                        <DatePicker
                            mode="day"
                            variant="button"
                            placeholder="Select"
                            clearable={overriddenKeys.has(milestone.key)}
                            value={resolvedDates[index]}
                            onValueChange={(date) =>
                                onExampleDatesChange(
                                    setMilestoneExampleDate({
                                        exampleDates,
                                        key: milestone.key,
                                        expectedDate: date,
                                    }),
                                )
                            }
                            fieldControlProps={{ "aria-labelledby": labelId }}
                            buttonProps={{ size: "md", variant: "primary" }}
                        />
                    </div>
                );
            })}
        </div>
    );
};
